import * as types from "../actions/ActionTypes";

const defaultState = {
  queue: []
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.GA_PUSH:
      return {
        ...state,
        queue: [...state.queue, action.payload]
      };

    case types.GA_PUSH_FIRST:
      return {
        ...state,
        queue: [action.payload, ...state.queue]
      };

    case types.GA_SHIFT:
      return {
        ...state,
        queue: state.queue.filter((_, i) => i > 0)
      };

    default:
      return state;
  }
}
